import {applyMiddleware, combineReducers, compose, createStore} from "redux";


import {thunk} from "redux-thunk";
import AuthReducer from "./reducers/authReducer.js";
import MainReducer from "./reducers/mainReducer.js";
import StaffReducer from "./reducers/staffReducer.js";
import RulesReducer from "./reducers/rulesReducer.js";
import FinanceReducer from "./reducers/financeReducer.js";
import ObjectsReducer from "./reducers/objectsReducer.js";
import PlanningReducer from "./reducers/planningReducer.js";
import GeneralStoreReducer from "./reducers/generalStoreReducer.js";
import MobileReducer from "./reducers/mobileReducer.js";
import AnaliticsReducer from "./reducers/analiticsReduser.js";


let reducers = combineReducers({
    authRDCR: AuthReducer,
    mainRDCR: MainReducer,
    staffRDCR: StaffReducer,
    rulesRDCR: RulesReducer,
    financeRDCR: FinanceReducer,
    objectsRDCR: ObjectsReducer,
    planningRDCR: PlanningReducer,
    generalStoreRDCR: GeneralStoreReducer,
    mobileRDCR: MobileReducer,
    analiticsRDCR: AnaliticsReducer

});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers,  composeEnhancers(applyMiddleware(thunk)));
window.store = store;


export default store;
